import { useEffect } from 'react';

import { sendEvent } from '../platform/analytics';
import { channel } from '../platform/channel';

export function Landing({ navigate, caseAppAvailable }: { navigate: (path: string) => void; caseAppAvailable: boolean }) {
  useEffect(() => { sendEvent('landing_view', 'ok', channel); }, []);
  return <>
    <main>
      <section className="container landing-focus" aria-labelledby="landing-title">
        <div className="landing-copy">
          <p className="landing-deck">보도차이 · 기사 변화 기록</p>
          <h1 id="landing-title">받은 기사 링크, 고쳐지거나 지워지기 전에 남겨 두세요.</h1>
          <p className="lede">기사 스크랩부터 정정보도 청구 준비까지, 같은 사건의 후속 보도와 공식 정정을 모아요. 어떤 원문을 언제 확인했는지 내 메모와 함께 다시 볼 수 있어요.</p>
          <button className="button primary landing-primary" disabled={!caseAppAvailable} onClick={() => navigate('/app')}>
            {caseAppAvailable ? '기사 저장하기' : '기사 기록 출시 준비 중'}
          </button>
          <p className="landing-boundary">기사 본문은 복사하지 않고 주소, 확인한 때, 내 메모만 보관해요.</p>
        </div>

        <figure className="case-sheet" aria-labelledby="case-sheet-title">
          <figcaption className="case-sheet-head">
            <span>기사 변화 기록 예시</span>
            <strong id="case-sheet-title">공공 발표 확인 기록</strong>
            <small>기사 3개를 한 흐름으로</small>
          </figcaption>
          <ol className="landing-timeline" aria-label="출처 확인과 정정 연결 세 단계">
            <li>
              <span className="event-step">1 · 주소 붙여넣기</span>
              <strong>공식 발표처 · 09:10</strong>
              <p>주소와 게시 시각을 원문에서 직접 확인했어요.</p>
            </li>
            <li>
              <span className="event-step">2 · 후속·정정 이어 붙이기</span>
              <strong>후속 확인처 · 11:40</strong>
              <p>출처가 말한 내용과 내가 확인할 점을 따로 적었어요.</p>
            </li>
            <li className="correction">
              <span className="event-step">3 · 정리본으로 꺼내기</span>
              <strong>정정 페이지 · 다음 날</strong>
              <p>본문 복사 없이 정정 링크와 시간 관계만 이어 놓았어요.</p>
            </li>
          </ol>
          <p className="case-sheet-note">기사 주소 · 게시/수정 시각 · 내 메모만 보관</p>
        </figure>
      </section>
      {channel==='web'&&<section className="container page"><h2>기사 기록을 시작하기 전에</h2><nav aria-label="기사 기록 안내"><a className="button secondary" href="/guide/correction-request">정정보도 청구 방법</a><a className="button secondary" href="/guide/news-scrap">기사 스크랩 정리방법</a><a className="button secondary" href="/guide/article-deletion">기사 삭제 요청 전 준비</a></nav></section>}
    </main>
  </>;
}
